import type { EsploraAddressUtxo } from '@ducat-unit/client-sdk';
import type { CoinUtxo, VaultHistoryProfile } from '@ducat-unit/core';

import type { VaultTransaction } from '../types';

export function convertVaultHistory(vaults: VaultHistoryProfile[]): VaultTransaction[] {
  return [...vaults].reverse().reduce((acc, v, index) => {
    const prev = acc[index - 1];
    //@ts-expect-error temporary mismatch between core-ts and validator
    const timestamp = v.block_stamp || v.block_timestamp || v.price_stamp || (prev ? prev.timestamp + 3600 : 0);
    const txid = v.coin_id?.split(':')[0];
    acc.push({
      transaction_id: txid || 'none',
      vault_id: v.root_txid,
      action: v.vault_action,
      amount_borrowed: v.unit_balance,
      vault_amount: v.vault_value || 0,
      net_collateral_sats: v.vault_balance ?? null,
      vault_ratio: v.vault_ratio ?? null,
      unit_amt: prev ? Math.abs(prev.amount_borrowed - v.unit_balance) : v.unit_balance,
      btc_amt: prev ? Math.abs(prev.vault_amount - (v.vault_value || 0)) / 100_000_000 : (v.vault_value || 0) / 100_000_000,
      timestamp,
      oracle_price: v.unit_price || prev?.oracle_price || 0,
      utxo: '',
      utxo_script: '',
      liquidation_hash: v.price_commits[0]?.thold_hash,
      liquidation_threshold: v.price_commits[0]?.thold_price,
      _date: new Date(timestamp * 1000),
    });
    return acc as VaultTransaction[];
  }, [] as VaultTransaction[]);
}

export const convertToCoinUtxos = async (utxosData: EsploraAddressUtxo[], address: string): Promise<CoinUtxo[]> => {
  const { parse_address } = await import('@vbyte/btc-dev/address');
  const parsedAddress = parse_address(address);

  const utxos: CoinUtxo[] = utxosData.map((e) => {
    const { txid, vout, value } = e;

    return { txid, vout, value, script_pk: parsedAddress.script.hex };
  });

  return utxos;
};
